import pluralize from 'pluralize'

const pluralizeHourAll = (period, hour) => pluralize(hour, period, true)

export default pluralizeHourAll
